import { Component, Input } from '@angular/core';
import { Locale } from 'src/app/model/locale';
import { AuthService } from 'src/app/services/auth/auth.service';
import { NavigationService } from 'src/app/services/navigation/navigation.service';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
})
export class ToolbarComponent {

  @Input() locale: Locale;
  @Input() displayProfile = true;
  @Input() title: string;

  constructor(
    private _authService: AuthService,
    private _navigationService: NavigationService
  ) { }

  goToProfile() {
    if (this._authService.isAuthenticated) {
      this._navigationService.goToProfile();
    } else { this._navigationService.goToLogin(); }
  }
}
